import {
	Card,
	Divider,
	Pagination,
	// Tabs,
	// Modal, Input, Select
} from 'antd';
import {
	useEffect,
	// useState
} from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import NativeNumber from '../../component/Numeral';

// import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';

import SearchFilter from '../../component/Filter';
import remakeQueryString from '../../methods/utils/remake-query-string';
import {
	// createProxyInvestment,
	investmentStatusCount,
	investmentTopUpList,
	investmentTopUpStatusCount,
	investmentWalletBalance,
	investmentWithdrawals,
	investmentWithdrawalStatusCount,
	retrieveAdminInvestmentItems,
	unregisteredInvestmentItems,
	// startProxyInvestment,
} from '../../methods/redux/reducers/investment';
import { getCurrencies } from '../../methods/redux/reducers/currency';
// import InvestmentWithdrawalItems from './InvestmentWithdrawalItems';
import InvestmentWithdrawalList from './InvestmentWithdrawalList';
import InvestmentWithdrawalStatusCount from './InvestmentWithdrawalCounts';

// const { TabPane } = Tabs;

const Style = styled.div`
	& .mini-report {
		& > * {
			display: inline-block;
			margin-right: 10px;
			margin-bottom: 10px;
		}
		& .amount {
			font-weight: 600;
			font-size: 16px;

			&.red {
				color: var(--red-color);
			}
		}
	}

	& .out-links {
		display: inline-block;
		margin-right: 20px;
		text-decoration: underline;
	}
`;

const InvestmentWithdrawals = () => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const {
		adminInvestmentItems,
		investmentBal,
		withdrawalList,
		investmentWithdrawalStatus,
	} = useAppSelector((store) => store.investment);
	const searchParamsObject = Object.fromEntries(searchParams);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: String(adminInvestmentItems.paginator?.perPage),
			});
		}

		dispatch(retrieveAdminInvestmentItems({ ...queryData }));
		dispatch(investmentStatusCount({}));
		dispatch(getCurrencies({}));
		dispatch(investmentWalletBalance({}));
		dispatch(investmentWithdrawalStatusCount({}));

		if (searchParamsObject.investmentId) {
			dispatch(
				investmentWithdrawals({
					...queryData,
				})
			);
		} else {
			dispatch(investmentWithdrawals({}));
		}
	}, []);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};
	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(retrieveAdminInvestmentItems({ ...queryData }));
			dispatch(investmentStatusCount({ ...queryData }));
			dispatch(unregisteredInvestmentItems({}));
			dispatch(investmentTopUpList({ ...queryData }));
			dispatch(investmentTopUpStatusCount({ ...queryData }));
			dispatch(investmentWithdrawals({ ...queryData }));
			dispatch(investmentWithdrawalStatusCount({ ...queryData }));
		}
	}, [searchParams]);

	const investmentFormSelect = [
		{
			name: 'REAL_ESTATE',
			value: 'REAL_ESTATE',
		},
		{
			name: 'STOCKS',
			value: 'STOCKS',
		},
	];
	return (
		<Style>
			<Card>
				<h1>Investment Withdrawals </h1>
				<p>
					This page displays a paginated and comprehensive list of all
					investments that can be withdrawn{' '}
				</p>
				<h2 style={{ marginTop: '25px', color: 'green' }}>
					<strong style={{ color: 'black' }}>Investment Wallet Balance:</strong>{' '}
					<NativeNumber value={investmentBal.balance} decimalPlaces={4} />{' '}
					{investmentBal.currency}
				</h2>
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
					}}
				>
					{/* <div style={{ marginRight: '10px' }}>
						<Button
							disabled={isStartInvestment}
							type="primary"
							onClick={() => setVisible(true)}
						>
							Start Investment
						</Button>
					</div> */}

					{/* <div>
						<Button
							disabled={!isStartInvestment}
							type="primary"
							onClick={() => setVisibleCreateInvestment(true)}
						>
							Create Investment
						</Button>
					</div> */}
				</div>
				<Divider />
				<strong>Withdrawal Counts:</strong>
				<div className="mini-report">
					<InvestmentWithdrawalStatusCount
						statusCount={investmentWithdrawalStatus}
					/>
				</div>
				<br />
				<Divider />

				<SearchFilter
					title="Search Investment Withdrawals"
					searchFilters={[
						{
							label: 'Withdrawal Status',
							name: 'withdrawalStatus',
							defaultSelectedValue: 'review',
							htmlElement: 'select',
							selectOptions: [
								{ name: 'review', value: 'review' },
								{ name: 'pending', value: 'pending' },
								{ name: 'processing', value: 'processing' },
								{ name: 'completed', value: 'completed' },
								{ name: 'cancelled', value: 'cancelled' },
							],
						},
						{
							label: 'investmentForm',
							name: 'investmentForm',
							htmlElement: 'select',
							selectOptions: investmentFormSelect,
						},
						{
							label: 'status',
							name: 'status',
							defaultSelectedValue: 'active',
							htmlElement: 'select',
							selectOptions: [
								{ name: 'active', value: 'active' },
								{ name: 'pending', value: 'pending' },
								{ name: 'deleted', value: 'deleted' },
							],
						},
					]}
					retrieveQueryString={updateQueryString}
				/>
				<br />
				<p>
					Total of <strong>{withdrawalList?.paginator?.itemCount} items</strong>{' '}
					found
				</p>
				<Divider />
				<div>
					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={withdrawalList?.paginator?.itemCount}
						current={withdrawalList?.paginator?.currentPage}
						pageSize={withdrawalList?.paginator?.perPage ?? 20}
					/>
				</div>
				<br />
				{/* <Tabs defaultActiveKey="1">
					<TabPane tab="Investments" key="1">
						{adminInvestmentItems &&
							adminInvestmentItems?.itemsList?.map((index: any) => (
								<InvestmentWithdrawalItems
									key={index._id}
									investmentProfile={index}
								/>
							))}
					</TabPane> */}
				{/* <TabPane tab="Withdrawal Lists" key="2"> */}
				{withdrawalList &&
					Array.isArray(withdrawalList?.itemsList) &&
					withdrawalList?.itemsList?.map((index: any) => (
						<InvestmentWithdrawalList key={index._id} list={index} />
					))}
				{/* </TabPane> */}
				{/* </Tabs> */}
				<br />
				<Pagination
					onChange={(pageId) => updateQueryString({ pageId })}
					total={withdrawalList?.paginator?.itemCount}
					current={withdrawalList?.paginator?.currentPage}
					pageSize={withdrawalList?.paginator?.perPage ?? 20}
					showSizeChanger
					showQuickJumper
				/>
			</Card>
		</Style>
	);
};

export default InvestmentWithdrawals;
